/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-02-20 09:37:22
 */
import getCellIdentity from './getCellIdentity';
import { findParentTd } from '@platform/api';
import { executeAutoFocus } from './findNextFocusItemInTable';
import calculateNeedJumpTimes from './calculateNeedJumpTimes';

/**
 * @desc 查找上一行元素
 * @param target {dom} 事件源
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 当前区域Id
 * @param orderOfHotKey {array} 区域显示顺序配置
 */
function findUpStairsFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey }) {
    let parentTd = eventTarget.tagName === 'TD' ? eventTarget : findParentTd(eventTarget);
    let upStairTr = parentTd.parentElement.previousElementSibling;
    let jumpedLines = 1; //向上跳跃的行数
    if (upStairTr === null) {return;}

    if (upStairTr.getAttribute('tabindex') === '-1') {
        jumpedLines = calculateNeedJumpTimes(upStairTr, jumpedLines, 'up');
    }

    let cellIdentity = getCellIdentity(parentTd);

    if (!cellIdentity) {
        return console.warn('not find cell identity!');
    }

    let cellIdentityArray = cellIdentity && cellIdentity.split('-');
    let upStairsLine = Number(cellIdentityArray.pop()) - jumpedLines;

    if (upStairsLine > -1) {
        cellIdentityArray.push(upStairsLine);
        let upStairsCellIdentity = cellIdentityArray.join('-');
        ViewModel.upStairsCellIdentity = cellIdentityArray;

        let div = document.querySelector(`div[${upStairsCellIdentity}="${upStairsCellIdentity}"] [tabindex="0"], div[${upStairsCellIdentity}="${upStairsCellIdentity}"][tabindex="0"]`);

        executeAutoFocus({ div, ViewModel });
    }
}
export { findUpStairsFocusItemInTable };
